import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { getResponseMessage } from '../../../../utils/utils';
import { buyOrder } from '../../../../crud/orders.crud';

export const useBuyOrder = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<any>(null);
  const [success, setSuccess] = useState(false);

  const fetchBuy = useCallback(async (orderId: number, callBack?: () => void) => {
    setLoading(true);

    try {
      if (callBack) {
        await callBack();
        await new Promise(resolve => setTimeout(resolve, 1800));
      }

      const res = await buyOrder(orderId);

      if (res.data?.data?.payment_url) {
        window.open(res.data.data.payment_url, '_self');
      }

      const checkRedirect = () => {
        if (window.location.href.includes('payment_success')) {
          setSuccess(true);
        }
      };

      // checkRedirect();
    } catch (e) {
      enqueueSnackbar(`Ошибка: ${getResponseMessage(e)}`, { variant: 'error' });
    } finally {
      setLoading(false);
      setErr(null);
      setSuccess(false);
    }
  }, []);

  return { fetchBuy, success, loading, err };
};
